import axios from 'axios';
import qs from 'qs';
import { useConfigHelper } from '@ilteducation/config';
import {
  CreateProfileRequest,
  CreateProfileResponse,
  GetProfileResponse,
  GetProfilesResponse,
  Page,
  Profile,
  UpdateProfileRequest,
  UpdateProfileResponse,
} from '@ilteducation/profile-types';

const { getApiUrl } = useConfigHelper();

export const getProfiles = async (context?: string, cursor?: string, limit?: number): Promise<Page<Profile>> => {
  const urlQs = qs.stringify({ context, cursor, limit });
  const params = urlQs ? `?${urlQs}` : '';

  const response = await axios.get(`${getApiUrl('profile')}/${params}`);
  return response.data as GetProfilesResponse;
};

export const getProfile = async (profileId?: string | number): Promise<Profile | null> => {
  const response = await axios.get(`${getApiUrl('profile')}/${profileId}`);
  if (response.status === 404) {
    return null;
  }
  return response.data as GetProfileResponse;
};

export const create = async (payload: CreateProfileRequest): Promise<Profile> => {
  const response = await axios.post(`${getApiUrl('profile')}/`, payload, {
    headers: { 'Content-Type': 'application/json' },
  });
  return response.data as CreateProfileResponse;
};

export const update = async (profileId: string, payload: UpdateProfileRequest): Promise<Profile> => {
  const response = await axios.patch(`${getApiUrl('profile')}/${profileId}`, payload, {
    headers: { 'Content-Type': 'application/json' },
  });
  return response.data as UpdateProfileResponse;
};

export const destroy = async (profileId: string): Promise<void> => {
  await axios.delete(`${getApiUrl('profile')}/${profileId}`);
};
